import { coreInitiativesFilesGetAsyncSlice } from './get';
import { coreInitiativesFilesPostAsyncSlice } from './post';

export const { requestGetCoreInitiativesFiles, resetGetCoreInitiativesFiles } =
	coreInitiativesFilesGetAsyncSlice.asyncActionCreators;

export const { requestPostCoreInitiativesFiles, resetPostCoreInitiativesFiles } =
	coreInitiativesFilesPostAsyncSlice.asyncActionCreators;

export * from './_id/actions';
